import styled from 'styled-components';

export const Container = styled.div`
  justify-content: center;
  align-items: center;
  margin: 10px;
  padding: 10px;

  p {
    color: #999999;
  }

  h2 {
    color: black;
  }

  ul {
    margin: 10px;
    list-style-type: none;
    color: #999999;
  }

  input {
    margin-right: 10px;
  }
`;
